export class ArticleContactViewModel {
    contactName: string;
    title: string;
    contactAddress: string;
    phoneNumber: string;
    mobileNumber: string;
    emailAddress: string;
    webAddress: string;
    imageData: string;
    articleContactId: number;
}
